<template>
    <div class="w-full bg-secondary mt-12 mb-12 py-6">
        <div class="orc-vert-limit-content">

            <h1 class="text-2xl mb-6"><i class="el-icon-message mr-3"></i>Contacteer ons</h1>

            <!-- Alert -->
            <el-alert v-if="error" title="Er ging iets mis, probeer later opnieuw!" type="error" effect="dark" :closable="false" show-icon class="mb-4"></el-alert>
            <el-alert v-if="send" title="Aanvraag geregistreerd!" description="Contact aanvraag geregistreerd, een verantwoordelijke neemt spoedig contact met u op." type="success" effect="dark" :closable="false" class="mb-4"></el-alert>

            <el-form ref="addEditForm" :rules="rules" :model="obj" status-icon>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item prop="name">
                            <el-input placeholder="Naam" v-model="obj.name" prefix-icon="el-icon-user"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="email">
                            <el-input placeholder="E-mail adres" v-model="obj.email" prefix-icon="el-icon-postcard"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item prop="branchId">
                            <el-select v-model="obj.branchId"
                                       placeholder="Tak"
                                       class="w-full">
                                <span slot="prefix"><i class="el-icon-medal pl-1"></i></span>
                                <el-option
                                        v-for="item in branchOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item prop="message">
                        <el-input
                                type="textarea"
                                :rows="2"
                                placeholder="Vul hier een bericht in.."
                                v-model="obj.message">
                        </el-input>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-button class="float-right" type="primary" :loading="loading" :disabled="send" @click="submitForm('addEditForm')">Verzenden<i class="ml-2 el-icon-right"></i></el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Contact",
        props: ['branchOptions'],
        data() {
            return {
                obj: {
                    name: "",
                    email: "",
                    branchId: "",
                    message: "",
                },

                loading: false,
                error: false,
                send: false,

                // Rules
                rules: {
                    name: [
                        {required: true, message: 'Vul een naam in.', trigger: 'blur'}
                    ],
                    email: [
                        {type:"email", required: true, message: 'Vul een email geldig email adres in.', trigger: 'blur'}
                    ],
                    branchId: [
                        {required: true, message: 'Selecteer een tak.', trigger: 'blur'}
                    ],
                    message: [
                        {required: true, message: 'Vul een bericht in.', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.error = false
                this.send = false
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.submitContactRequest();
                    } else {
                        return false;
                    }
                });
            },
            submitContactRequest() {
                this.$http.post('contact', this.obj).then((response) => {
                    this.loading = false
                    this.error = false
                    this.send = true
                }).catch((error) => {
                    this.error = true
                    console.log(error);
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/home/contact/Contact.vue